import { List, Map, fromJS } from 'immutable'
import { Component } from 'react'
import { v4 as uuidv4 } from 'uuid';

import ImagesMovieDisplayAndUploadComponent from './ImagesMovieDisplayAndUploadComponent'

class ImagesMovieDisplayAndUpload extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isUploading: false,
            isDeleting: false,
            errorMessageUpload: false,
            errorMessageDelete: false,
            images: []
        }

        this.onUploadStart = this.onUploadStart.bind(this)
        this.onUploadEndSuccess = this.onUploadEndSuccess.bind(this)
        this.onUploadEndError = this.onUploadEndError.bind(this)
        this.onResetErrorMessages = this.onResetErrorMessages.bind(this)
    }

    componentDidMount() {
        this.setItems()
    }

    componentDidUpdate(prevProps) {
        const prevValue = prevProps.field.value
        const nextValue = this.props.field.value
        const ambientChanged = prevValue.ambient !== nextValue.ambient
        const backgroundsChanged = prevValue.backgrounds !== nextValue.backgrounds
        if (ambientChanged || backgroundsChanged) {
            this.setItems()
        }
    }

    onUploadStart() {
        this.setState({
            isUploading: true
        })
    }

    onUploadEndError(error) {
        this.setState({
            errorMessageUpload: error,
            isUploading: false
        })
    }

    onUploadEndSuccess() {
        this.setState({ 
            errorMessageUpload: false,
            isUploading: false
        })
    }

    onResetErrorMessages() {
        this.setState({
            errorMessageUpload: false,
            errorMessageDelete: false
        })
    }

    setItemId(item) {
        return {
            itemId: uuidv4(),
            ... item
        }
    }

    setItems() {
        const { field } = this.props 
        let images =[]

        if(field.value.ambient) {
            images.push(this.setItemId(field.value.ambient))
        }

        if(field.value.backgrounds && Array.isArray(field.value.backgrounds) && field.value.backgrounds.length > 0) {
            field.value.backgrounds.map(img => {
                if(img.id || undefined === images.find(i => i.url === img.url)) {
                    images.push(this.setItemId(img))
                }
            })
        }
        
        this.setState({
            images: images
        })
    }

    render() {
        const { errorMessageUpload, isUploading, images } = this.state
        const { form, setMovieImages, onImagesTouched, imageType, autoUpload } = this.props
        const movieTitle = form.values.movie.title ? form.values.movie.title : 'Movie image'
        const isDisabled = false
        const errorMessages = [errorMessageUpload]

        return <ImagesMovieDisplayAndUploadComponent
            images={images}
            movieTitle={movieTitle}
            isDisabled={isDisabled}
            imageType={imageType}
            isUploading={isUploading}
            errorMessages={errorMessages}
            autoUpload={autoUpload}
            onUploadStart={this.onUploadStart}
            onUploadEndSuccess={this.onUploadEndSuccess}
            onUploadEndError={this.onUploadEndError}
            onResetErrorMessages={this.onResetErrorMessages}
            setMovieImages={setMovieImages}
            onImagesTouched={onImagesTouched}
        />
    }
}

export default ImagesMovieDisplayAndUpload